export default "__VITE_PUBLIC_ASSET__c4abe73b__"